import React from "react";
import { Typography } from "..";
import CheckBold from "@tiny/icons/generated/CheckBold";
import { isEqual } from "./SelectList.helpers";
import { useStyles } from "./SelectList.styles";

import { SelectListProps } from "./SelectList.types";

function SelectList(props: SelectListProps) {
  const { options, value, onChangeValue } = props;

  const classes = useStyles();

  return (
    <ul role="listbox" className={classes.root}>
      {options.map((option) => (
        <li
          key={option.value}
          className={classes.item}
          role="option"
          aria-selected={isEqual(option.value, value)}
          onClick={() => onChangeValue?.(option.value)}
        >
          <Typography
            className={classes.text}
            variant="body2"
            color="grey"
            tone={800}
          >
            {option.label}
          </Typography>
          {isEqual(option.value, value) && (
            <CheckBold className={classes.check} />
          )}
        </li>
      ))}
    </ul>
  );
}

export default React.memo(SelectList);
